import React from 'react';

import { Languages } from '../components/languages';
import {
    ajax, plainDate, dateObj,myDeepCopy, getNavigation, loadOrganizationCarrier, downloadCsv,
    ellipsisText, dateStr
} from '../components/globals';

import { ModalBox, UButton, UButtonGroup, UCardTitle, UInput, UItemsList, UTitle, ULabel, UDate, USelect} from '../components/utilities';
import { UISummary, UIFilterPanel, UISummaryWidget, UISummaryWidgetBar, PageTitle, UIDataTable, UIDownload, ScrollableGrid, ScrollableGridItem, UIPopup, UIInput, UIButton, UIButtonPad, UICheckbox, UIMessageBox, UISelect, UIMultiSelect } from '../components/guiElements';




class TrackingEvents extends React.Component {
    render() {
        const items = this.props.items.map((el, idx) => (
            <div className="tracking-event">
                <div className="tracking-title">{el.text}</div>
                <div className="tracking-value">{el.value}</div>
            </div>), this);

        return <div className="tracking-events">{items}</div>;
    }
}


export default class Tracking extends React.Component {
    constructor(props) {
        super(props);

        //#region Methods binding
        //this.filtersClick = this.filtersClick.bind(this);
        this.filtersChange = this.filtersChange.bind(this);
        this.downloadExcel = this.downloadExcel.bind(this);
        this.trackClick = this.trackClick.bind(this);
        this.trackUrlClick = this.trackUrlClick.bind(this);
        this.dashFilterChange = this.dashFilterChange.bind(this);
        //this.closeModal = this.closeModal.bind(this);
        this.getTotals = this.getTotals.bind(this);
        this.getData = this.getData.bind(this);
        //#endregion Methods binding

        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.le = Languages.Tracking[Languages.selectedLanguage];
        this.leMain = Languages.Main[Languages.selectedLanguage];
        let filters = {};
        Object.entries(this.le.filters.items).forEach(([key, val]) => { filters[key] = ""; });

        this.configs = {
            dashboardItems: [
                { name: 'delivered', color:'#29ff00', icon:'../../images/tracking/checked.png' },
                { name: 'exceptions', color: '#f00', icon: '../../images/tracking/Reso.svg' },
                { name: 'delivering', color: '#5ca0fc', icon: '../../images/tracking/clock.png' },
                { name: 'tentatives', color: '#f9ae31', icon: '../../images/tracking/alert.png' },
                { name: 'transit', color: '#02589d', icon: '../../images/tracking/arrows.png' },
                { name: 'sent', color: '#9c1ede', icon: '../../images/tracking/Spedito.svg' }
            ],
            filters: {
                orderNum: { type: "text" },
                carrier:{ type: "select"},
                dateFrom: { type: "date" },
                recipient: { type: "text", width: "20%" },
                barcode: { type: "text", width: "20%" },
                status: { type: "select" }
            }
        };

        this.header = [
            {
                generic: { manage: 0, name: 'orderNum', width: 20, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold', value: this.le.captions[0] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            },
            {
                generic: { manage: 0, name: 'customer', width: 30, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold', value: this.le.captions[1] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            }, {
                generic: { manage: 0, name: 'tracking id', width: 25, change: null, click: this.trackClick },
                caption: { type: 'label', colClass: null, itemClass: 'bold', value: this.le.captions[2] },
                element: { type: 'link', colClass: null, itemClass: null, options: null }
            },
            {
                generic: { manage: 0, name: 'tracking url', width: 10, change: null, click: this.trackUrlClick },
                caption: { type: 'label', colClass: null, itemClass: 'bold', value: this.le.captions[3] },
                element: { type: 'link', colClass: null, itemClass: null, options: null }
            }
            , {
                generic: { manage: 0, name: 'status', width: 15, change: null, click: null },
                caption: { type: 'label', colClass: null, itemClass: 'bold', value: this.le.captions[4] },
                element: { type: 'label', colClass: null, itemClass: null, options: null }
            }];
        this.listKey = 0;

        //#region Automatic Support Data
        let mngIdx = 0, entIdx = 0;
        this.dataIndexes = this.header.map((el) => ({ manage: el.generic.manage, name: el.generic.name, idx: (el.generic.manage > 0 ? mngIdx++ : entIdx++) }));
        this.defaultManager = this.header.filter((el) => (el.generic.manage > 0)).map((el) => (el.generic.default));
        //#endregion Automatic Support Data

        let dtTo = new Date();
        let dtFrom = new Date();
        dtFrom.setDate(dtTo.getDate() - 7);

        this.appliedFilters = filters;
        this.state = {
            filters: filters,
            trackedList:[],
            entries: [],
            managers: Array(1).fill().map((el) => (this.defaultManager.slice())),
            dashboard: this.buildDashboardData(null),
            dashFilter: { dateFrom: dateStr(dtFrom), dateTo: dateStr(dtTo)},
            modalType: 0,
            modalSource: '',
            modalList: [],
            carriers:[]
        };
    }

    //#region Data functions

    findTrackItem(orderNum)
    {
        let track = this.state.trackedList.find(a => a.orderNum == orderNum);

        if (track == undefined)
            return null;
        return track;

    }

    getData(navigation) {
        try {

            this.props.loaderShow(0);
            const filters = encodeURIComponent(JSON.stringify(this.appliedFilters));
            const url = '/api/tracking/list/' + navigation.pageNo.value + '/' + navigation.pageSize.value + '/' + filters;
            ajax(this, { method: 'get', url: url, headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
                response => {
                    
                    this.props.loaderHide();
                    let entries = this.buildEntries(response.data.result.fullList);

                    navigation.totalItems.value = response.data.result.totItems;

                    this.setState({
                        trackedList: response.data.result.fullList,
                        entries: entries,
                        managers: Array(entries.length + 1).fill().map(() => (this.defaultManager.slice())),
                        navigation: navigation
                    });

                   
                },
                error => {

                    this.props.loaderHide();
                    const msg = Languages.Main[Languages.selectedLanguage].messages.msgError;
                    /*
                    let obj = {
                        title: msg.title,
                        width: "35%",
                        icon: "error",
                        messages: msg.messages,
                        buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: null }]
                    };
                    this.props.popUp(obj);*/

                    this.props.popupErrorMessage(msg.messages);

                }
            );
        }
        catch (e)
        {
            this.props.loaderHide();
        }
    }

    getTotals(ok, ko) {
        const filters = encodeURIComponent(JSON.stringify(this.state.dashFilter));
        const url = '/api/tracking/totals/' + filters;
        ajax(this, { method: 'get', url: url, headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
            response => {

                let dashboard = this.buildDashboardData(response);

                                
                this.setState({ dashboard: dashboard });
                if (ok != undefined)
                    ok.call(this);

                /*
                let navigation = JSON.parse(JSON.stringify(this.props.data.navigation));
                navigation.pageSize.text = Languages.Main[Languages.selectedLanguage].navigation[0];
                navigation.pageSize.change = this.changePageSize;
                navigation.pageNo.change = this.changePageNo;
                this.getData(navigation);*/
            },
            error => {
                const msg = Languages.Main[Languages.selectedLanguage].messages.msgError;
                /*
                let obj = {
                    title: msg.title,
                    width: "35%",
                    icon: "error",
                    messages: [error.message],
                    buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: null }]
                };*/

                if (ko != undefined)
                    ko.call(this);
                //this.props.popUp(obj);

                this.props.popupErrorMessage(msg.messages);

            }
        );
    }
    buildDashboardData(response) {
        let dashboard =  {
            shipments: "0",
            days: "7",
            totals: "0",
            items: {
                delivered: { value: '-', percentage: '-' },
                exceptions: { value: '-', percentage: '-' },
                delivering: { value: '-', percentage: '-' },
                tentatives: { value: '-', percentage: '-' },
                transit: { value: '-', percentage: '-' },
                sent: { value: '-', percentage: '-' }
            }
        }

        if (response != null) {
            dashboard.daysFrom = response.data.result.totals.daysFrom;
            dashboard.from = response.data.result.totals.from;
            dashboard.to = response.data.result.totals.to;
            dashboard.totals = response.data.result.totals.totals ;
            dashboard.shipments =  response.data.result.totals.shipments ;
            dashboard.items.delivered.value =  response.data.result.totals.delivered;
            dashboard.items.delivering.value =  response.data.result.totals.delivering ;
            dashboard.items.transit.value = response.data.result.totals.transit ;
            dashboard.items.exceptions.value =  response.data.result.totals.exceptions ;
            dashboard.items.tentatives.value =  response.data.result.totals.tentatives ;
            dashboard.items.sent.value =  response.data.result.totals.sent;
            const divid = dashboard.shipments || 1;
            dashboard.items.delivered.percentage =  (100 * response.data.result.totals.delivered / divid).toFixed().toString() + "%" ;
            dashboard.items.exceptions.percentage = (100 * response.data.result.totals.exceptions / divid).toFixed().toString() + "%" ;
            dashboard.items.delivering.percentage = (100 * response.data.result.totals.delivering / divid).toFixed().toString() + "%" ;
            dashboard.items.tentatives.percentage = (100 * response.data.result.totals.tentatives / divid).toFixed().toString() + "%" ;
            dashboard.items.transit.percentage = (100 * response.data.result.totals.transit / divid).toFixed().toString() + "%" ;
            dashboard.items.sent.percentage =  (100 * response.data.result.totals.sent / divid).toFixed().toString() + "%";
        }
        return dashboard;
    }
    buildEntries(trackList) {
        let entries = trackList.map(el => ([
            el.orderNum,
            el.customer,
            ellipsisText(el.trackingId,40),
            el.trackingUrl != null && el.trackingUrl!=''? "vedi":"",
            el.trackingStatus,
            el.events
        ]));

        return entries;
    }

    loadCarrier() {

        loadOrganizationCarrier(this.uc.jwtToken,
            (response) => {
               
                this.setState({
                    carriers: response.map((val) => { return { value: val.name, text: val.name };})
                });
            },
            (error) => {



            });
    }

    //#endregion Data functions

    //#region Events

    componentDidMount() {
        this.getTotals();

        let navigation = getNavigation(this.getData, this.leMain.navigation);

        this.getData(navigation);

        this.loadCarrier();
    }

    dashFilterChange(ev) {
        let name = ev.target.name;
        let value = ev.target.value;
        let dashFilter = JSON.parse(JSON.stringify(this.state.dashFilter));
        dashFilter[name] = value;
        this.setState({ dashFilter: dashFilter });
        try {
            this.props.loaderShow();
            this.getTotals(
                ok => {
                    this.props.loaderHide();
                },
                ko => {
                    this.props.loaderHide();
                });
        }
        catch{
            this.props.loaderHide();
        }
    }

    filtersChange(ev) {
        let name = ev.target.name;
        let value = ev.target.value;
        let newFilters = JSON.parse(JSON.stringify(this.state.filters));
        newFilters[name] = value;
        this.setState({ filters: newFilters });

        if (JSON.stringify(newFilters) !== JSON.stringify(this.appliedFilters)) {
            this.appliedFilters = newFilters;
            let newNavig = myDeepCopy(this.state.navigation);
            newNavig.pageNo.value = 0;
            this.getData(newNavig);
        }
    }

    /*filtersClick(ev) {
        //alert("filter");
        if (JSON.stringify(this.state.filters) !== JSON.stringify(this.appliedFilters)) {
            this.appliedFilters = JSON.parse(JSON.stringify(this.state.filters));

            let newNavig = myDeepCopy(this.state.navigation);
            newNavig.pageNo.value = 0;
            this.getData(newNavig);
        }
    }*/

    downloadExcel(ev) {
        try {

            downloadCsv(this.uc.jwtToken,'track', this.state.navigation.pageNo.value, this.state.navigation.pageSize.value,
                this.state.filters,
                error => {

                    const msg = Languages.Main[Languages.selectedLanguage].messages.msgError;
                   

                    this.props.popupErrorMessage(msg.messages);

                }, this);


        }
        catch (e)
        {

            const msg = Languages.Main[Languages.selectedLanguage].messages.msgError;
           
            this.props.popupErrorMessage(msg.messages);

        }
    }

    trackUrlClick(ev, row, id) {

        ev.preventDefault();

        let track = this.findTrackItem(id);
        if (track != null && track.trackingUrl != null && track.trackingUrl!='')
            window.open(track.trackingUrl, '_blank');
        // else msgbox ??
    }

    trackClick(ev, row, id) {
       
        ev.preventDefault();

        let track = this.findTrackItem(id);
        if (track && track.events) {
            let trackList = track.events.map(el => (
                [plainDate(el.eventDate,true), el.eventDesc]
            ));
            this.setState({ modalType: 1, modalSource: id, modalList: trackList });
        }
        // else msgbox ??
    }

    /*closeModal(ev) {
        this.setState({ modalType: 0, modalSource: '', modalList: [] });
    }*/
    
    //#endregion Events

    render() {
        //#region Data Structures
       
        let filters = {};
        Object.entries(this.configs.filters).forEach(([key, val]) => {
            filters[key] = Object.assign({ value: this.state.filters[key] }, val);
        }, this);

        filters.carrier.options = [{ text: this.le.filters.allCarrier, value: "" }].concat(this.state.carriers);
        filters.status.options = this.le.filters.trackStatus;

        const le = this.le.dashboard, data = this.state.dashboard;
        const items = this.configs.dashboardItems.map(el => {
            const chuncks = le.items[el.name].subTitle.split("%par%");
            return Object.assign({
                texts: { first: le.items[el.name].title, second: chuncks[0] + data.items[el.name].value + chuncks[1], percentage: data.items[el.name].percentage }
            }, el);
        });
        //#endregion Data Structures

        let modal = null;
        if(this.state.modalType) {
            const items = this.state.modalList.map(el => ({ text: el[0], value: el[1] }));
            modal = <UIPopup onCancel={ev => this.setState({ modalType: null })} title={this.le.tracking.title.replace("%par%", this.state.modalSource)} buttons={[ <UIButton key="btn" text="Ok" onClick={ev => this.setState({ modalType: null })} /> ]}>
                <TrackingEvents name={this.state.modalSource} items={items} />
            </UIPopup>
        }


        const titChuncks = le.title.split('%par%');
        let summaryRange = <div className="summary-range">
            <div className="summary-range-filter">
                <label>{titChuncks[0] + ' ' + this.state.dashboard.shipments + ' ' + titChuncks[1]}</label>
                <UIInput type="date" name="dateFrom" maxDate={this.state.dashFilter.dateTo} onChange={this.dashFilterChange} value={this.state.dashFilter.dateFrom} />
                <label>{titChuncks[2]}</label>
                <UIInput type="date" name="dateTo" maxDate={new Date()} onChange={this.dashFilterChange} value={this.state.dashFilter.dateTo} />
            </div>
            <div className="summary-range-notes">
                {le.message}
            </div>
        </div>;
            
        let pageFilters = Object.entries(filters).map(([key, val]) => {
            let field = val.type === "select"
                ? <UISelect key={key} name={key} options={val.options} value={val.value} onChange={this.filtersChange} />
                : <UIInput key={key} type={val.type} name={key} maxDate={new Date()} onChange={this.filtersChange} value={val.value} hint={this.le.filters.items[key]} />;
            return field;
        }, this);
        pageFilters.push(<UIDownload title={this.le.button} onClick={this.downloadExcel} />);

        return (<div className="page-tracking">

            <PageTitle icon="../images/mainMenu/TrackNTrace.png" title={Languages.getSection('Main').menuLabels.trackAndTrace} />
            <div className="page-content">

                {summaryRange}                

                <UISummary >
                    <UISummaryWidgetBar>
                        {
                            this.configs.dashboardItems.map((el,idx) => {
                                const chuncks = le.items[el.name].subTitle.split("%par%");

                                return <UISummaryWidget key={"sum-" + idx}
                                    className=""
                                    title={le.items[el.name].title}
                                    mainLabel={chuncks[1]}
                                    subLabel=""
                                    mainScore={chuncks[0] + data.items[el.name].value}
                                    subScore={data.items[el.name].percentage} />

                                /*return Object.assign({
                                    texts: {first: le.items[el.name].title, second: chuncks[0] + data.items[el.name].value + chuncks[1], percentage: data.items[el.name].percentage }
                                }, el);*/
                            })
                        }
                    </UISummaryWidgetBar>
                    
                </UISummary>

                <UIFilterPanel>
                    {pageFilters}                    
                </UIFilterPanel>

                <UIDataTable header={this.header} entries={this.state.entries} listKey={this.listKey} managers={this.state.managers} navigation={this.state.navigation} />


            </div>

            {modal}
        </div>);

        /*return (
            <div id={this.constructor.name}>
                <div className="container-fluid"><div className="row"><div className="col">
                    <TrackingDashboard onChange={this.dashFilterChange} 
                    data={{ 
                        dashFilter: this.state.dashFilter, 
                        dashboard: this.state.dashboard, 
                        shipments: data.shipments, 
                        totals: data.totals }} 
                    items={items}
                    texts={{ 
                        dashFilterTitleFrom: le.dashFilterTitleFrom, 
                        dashFilterTitleTo: le.dashFilterTitleTo,
                        title: le.title, 
                        message: le.message, 
                        bodyTitle: le.bodyTitle, 
                        bodySubTitle: le.bodySubTitle 
                    }} />
                    
                    <TrackingFilters 
                        texts={this.le.filters} 
                        data={filters} 
                        onChange={this.filtersChange} 
                        onClick={this.filtersClick} />

                    <TrackingItemsList 
                        listKey={this.listKey} 
                        header={this.header} 
                        entries={this.state.entries} 
                        managers={this.state.managers}
                        button={{ text: this.le.button, click: this.downloadExcel }} 
                        navigation={this.state.navigation} />
                </div></div></div>
                {modal}
            </div>
        );*/
    }
}


